import React from "react";

import { GTM_EVENT_COOKIES_DECLINED } from "@config/consts";

import { useAuth } from "@hooks/useAuth";
import { useGTM } from "@hooks/useGTM";

const Cookiebot = (): null => {
  const gtm = useGTM();
  const { user } = useAuth();

  const handleCookiebotDecline = () => {
    gtm.push({
      event: GTM_EVENT_COOKIES_DECLINED,
      clientId: user?.get("identifier"),
    });
  };

  React.useEffect(() => {
    window.addEventListener("CookiebotOnDecline", handleCookiebotDecline);
  }, []);

  return null;
};

export { Cookiebot };
